module.exports = __webpack_public_path__ + "img/ingeray.0f3e91c3.svg";